import React from 'react';
import { useConfig } from '../../ConfigContext';
import { percentToTime, timeToPercent } from '../../../utils/overlayMath';

export default function MusicPanel() {
  const { music, setMusicState, general, setGeneralState } = useConfig();

  return (
    <div>
      <div>
        <label className="custom-label">Název písničky</label>
        <input
          className={`w-full p-2`}
          value={music.name}
          onChange={(e) => setMusicState({ name: e.target.value })}
          placeholder="Zadejte název písničky"
        />
      </div>

      {/* Malý text */}
      <div>
        <label className="custom-label">Interpret</label>
        <input
          className={`w-full p-2`}
          value={music.interpret}
          onChange={(e) => setMusicState({ interpret: e.target.value })}
          placeholder="Např. Imagine Dragons"
        />
      </div>

      <div className="flex justify-between">
        <div>
          <label className="custom-label">Čas aktuální</label>
          <input
            className={`w-full p-2`}
            value={music.timeStart}
            onChange={(e) => setMusicState({ timeStart: e.target.value })}
            placeholder="1:22"
          />
        </div>
        <div>
          <label className="custom-label">Celková délka</label>
          <input
            className={`w-full p-2`}
            value={music.timeEnd}
            onChange={(e) => setMusicState({ timeEnd: e.target.value })}
            placeholder="2:45"
          />
        </div>
      </div>
      <div className="w-full flex items-center zooming mb-8 mt-4">
        <input
          id="zoom"
          type="range"
          min="0"
          max={music.timeEnd}
          step="0.01"
          value={timeToPercent(music.timeStart, music.timeEnd)}
          onChange={(e) =>
            setMusicState({
              timeStart: percentToTime(
                parseFloat(e.target.value),
                music.timeEnd
              ),
            })
          }
          className="w-full flex-1 w-[50%]"
          style={{
            background: '#874fb7',
            color: '#874fb7',
            accentColor: '#874fb7',
          }}
        />
      </div>
      <div>
        <div className="flex items-center gap-2 mt-1">
          <label
            className="inline-flex items-center me-5 cursor-pointer"
            htmlFor="sound-like-checkbox"
          >
            <input
              type="checkbox"
              value=""
              className="sr-only peer"
              id="sound-like-checkbox"
              checked={general.soundLike}
              onChange={(e) => setGeneralState({ soundLike: e.target.checked })}
            />
            <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-focus:ring-4 peer-focus:ring-purple-300 dark:peer-focus:ring-purple-800 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-purple-600 dark:peer-checked:bg-purple-600"></div>
            <span className="ms-3 text-md font-medium">Like na písničku</span>
          </label>
        </div>
      </div>
    </div>
  );
}
